import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00364 = new TileLayer({
  title: 'Máscara 19930919',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19930919l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00364.setVisible(false);

const layer00363 = new TileLayer({
  title: 'Máscara 19931021',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19931021l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00363.setVisible(false);

const layer00362 = new TileLayer({
  title: 'Máscara 19940125',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19940125l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00362.setVisible(false);

const layer00361 = new TileLayer({
  title: 'Máscara 19940314',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19940314l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00361.setVisible(false);

const layer00360 = new TileLayer({
  title: 'Máscara 19940501',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19940501l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00360.setVisible(false);

const layer00359 = new TileLayer({
  title: 'Máscara 19940704',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19940704l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00359.setVisible(false);

export const grupoCapa01_28 = new LayerGroup({
  title: 'Ciclo Hidrológico 1993-1994',
  fold: 'close',
  layers: [layer00359, layer00360, layer00361, layer00362, layer00363, layer00364]
});